<div class="mt-2 row">
    <div class="col-12 align-items-center justify-content-center mt-1">
        <h5 class="mb-0 game-text">
            <span #metricText class="variation-ellipsis" 
                [tooltip]="checkTextTruncation(game?.SelectedMetrics[0]?.abbrev, TooltipType.Q1)" placement="top" container="body" containerClass="tooltip-custom-bullseye"
                (mouseenter)="tooltip.show()"
                triggers="manual"
                #tooltip="bs-tooltip"
                (mouseleave)="tooltip.hide()"
                (wheel)="tooltip.hide()">
                {{game?.SelectedMetrics[0]?.abbrev}}:
            </span>
            <span class="mr-1 game-text-detail" *ngIf="gameStatus === 'Upcoming'">--</span>
            <span class="mr-1 game-text-detail"
                *ngIf="gameStatus !== 'Upcoming'">{{gs.getMetricValue(game?.SelectedMetrics[0]?.conversionType, ranking?.gameRewards?.MyRankingObj)}}</span>
        </h5>
    </div>
</div>
<cxone-game-qualifier *ngIf="game.Qualifier !== null" [game]="game" [ranking]="ranking" [gameStatus]="gameStatus" [checkTextTruncation]="checkTextTruncation"></cxone-game-qualifier>
<div class="bullseye-container">
    <ng-container *ngFor="let reward of game?.BullseyeRewards; let i = index; let total = count">
        <div class="bullseye" [ngClass]="'circle-' + (i + 1)" 
             [ngbPopover]="popoverContent"
             triggers="mouseenter:mouseleave" 
             popoverClass="cxone-bullseye-tooltip"
             [ngStyle]="getRingStyle(i, total)" 
             placement="top"
             container="body"
             #tooltipBullseye="ngbPopover"
             (mouseenter)="tooltipBullseye.open()" 
             (mouseleave)="tooltipBullseye.close()"
             (wheel)="tooltipBullseye.close()">
        </div>
        <ng-template #popoverContent>
            <div class="d-flex flex-column">
                <span class="popup-title">{{getPopoverTitle(i, total)}}</span>
                <span class="tooltip-text">{{getTooltipMetric(i, total)}}</span>
                <div class="d-flex reward-container align-items-center">
                    <span class="d-flex align-items-center">
                        <svg class="icon-16">
                            <use href="../../../App_Themes/CXone/icons/gamification/games/coin-reward.svg#coin-reward"></use>
                        </svg>
                        <span class="tooltip-text ml-1">{{game?.BullseyeRewards[total - 1 - i]?.Coins?.rewardValue | cvNumberLocalize}}</span>
                    </span>
                    <span class="d-flex badge align-items-center">
                        <svg class="icon-16">
                            <use href="../../../App_Themes/CXone/icons/gamification/games/badge-reward.svg#badge-reward"></use>
                        </svg>
                        <span>
                            <div class="ml-1" *ngIf="game?.BullseyeRewards[total - 1 - i]?.Badge !== null">
                                <img *ngIf="game?.BullseyeRewards[total - 1 - i]?.Badge?.rewardValue !== 0; else doubleDash"
                                     [src]="'../Admin/ImageResizer.aspx?imgid=' + game?.BullseyeRewards[total - 1 - i]?.Badge?.rewardValue + '&w=24&h=24'">
                            </div>
                            <ng-template #doubleDash>
                                <span class="text-double-dash ml-2"> -- </span>
                            </ng-template>
                        </span>
                    </span>
                </div>
            </div>
        </ng-template>
    </ng-container>
</div>